import { request } from '@koi-design/vix-tools';
import { prefixApi } from './urls';
import type { GetWorkWxTicketRequest, GetLoginUrlRequest } from './types/wxAuth';

/**
 * 获取企业微信认证链接
 * @param corpId 企业ID
 * @returns 认证链接字符串
 */
export const getCertificationUrlApi = async (corpId: string): Promise<string> => {
  return request({
    url: `${prefixApi}/wxAuth/certificationUrl/${corpId}`,
    method: 'get'
  });
};

/**
 * 获取企业微信JS-SDK所需的票据信息
 * @param params 请求参数
 * @returns JS-SDK签名信息
 */
export const getWorkWxTicketApi = async (params: GetWorkWxTicketRequest) => {
  return request({
    url: `${prefixApi}/wxAuth/getWorkWxTicket`,
    method: 'post',
    data: params
  });
};

/**
 * 获取企业微信应用JS-SDK所需的票据信息
 * @param params 请求参数
 * @returns 应用JS-SDK签名信息
 */
export const getWorkWxAgentTicketApi = async (params: GetWorkWxTicketRequest) => {
  return request({
    url: `${prefixApi}/wxAuth/getWorkWxAgentTicket`,
    method: 'post',
    data: params
  });
};

/**
 * 获取企业微信登录链接
 * @param params 请求参数
 * @returns 登录链接字符串
 */
export const getLoginUrlApi = async (params: GetLoginUrlRequest): Promise<string> => {
  return request({
    url: `${prefixApi}/wxAuth/getLoginUrl`,
    method: 'post',
    data: params
  });
};
